import React from 'react';

const SchemaContext = React.createContext('');

export default SchemaContext;

